import { Grid } from '@mui/material';
import React, { useMemo } from 'react';
import { GroupedContainer } from '../../../ContratosCreation/components/GroupedContainer';
import { RenderInputsRowByType } from '../../../../components/formGroupGenerator/RenderInputRowByType';


export const StepDatosGenerales = ({
    fullFormData,
    handleChangeFullFormData,
    docuRespaldatoriaCombo,
    presentacionFactCombo,
    tipoAutorizacionCombo,
    tiempoFacturacionCombo,
    allowedWrite
}) => {

    const handleChange = (name, value) => {
        handleChangeFullFormData(name, value);
    }

    const parsedInputs = useMemo(() => {
        return structuredClone(inputsGroups).map(group => ({
            ...group,
            row: {
                inputs: group.row.inputs.map(input => {
                    switch (input.name) {
                        case 'idTmpFact':
                            input.options = tiempoFacturacionCombo.map(x => ({ id: x.idTmpFact.toString(), displayName: x.descripcion }));
                            break;
                        case 'presentacionFact':
                            input.options = presentacionFactCombo.map(x => ({ id: x.idPresentacionFact.toString(), displayName: x.descripcion }));
                            break;
                        case 'docRespaldatoria':
                            input.options = docuRespaldatoriaCombo.map(x => ({ id: x.idDocumentacionRespaldatoria.toString(), displayName: x.descripcion }));
                            break;
                        case 'idTipoAutorizacion':
                            input.options = tipoAutorizacionCombo.map(x => ({ id: x.idTipoAutorizacion.toString(), displayName: x.descripcion }));
                            break;
                        default:
                            break;
                    }

                    if (!allowedWrite) {
                        input.disabled = true;
                    }

                    return input;
                })
            }
        }));
    }, [
        tiempoFacturacionCombo,
        tipoAutorizacionCombo,
        presentacionFactCombo,
        docuRespaldatoriaCombo,
        allowedWrite
    ]);

    return (
        <div>
            <Grid
                container
                columnSpacing={3}
                rowSpacing={3}
                columns={100}
            >
                {parsedInputs?.map((group, index) => {
                    return <GroupedContainer key={index} ungrouped={!group.groupName} sectionTitle={group.groupName}>
                        {group.row.inputs.map((input, inputIndex) => {
                            return (
                                <RenderInputsRowByType
                                    key={inputIndex}
                                    input={input}
                                    value={fullFormData[input.name]}
                                    handleChange={handleChange}
                                />
                            )
                        })}
                    </GroupedContainer>
                })}
            </Grid>
        </div>
    )
}

const inputsGroups = [
    {
        row: {
            inputs: [{
                displayName: 'Nombre',
                name: 'nombre',
                type: 'string',
                disabled: true,
                col: 33,
            },
            {
                displayName: 'Código SAP',
                name: 'codSap',
                type: 'string',
                disabled: true,
                col: 18
            },
            {
                displayName: 'Oficina de Ventas',
                name: 'oficinaVentas',
                type: 'string',
                disabled: true,
                col: 33
            },
            {
                displayName: 'CUIT',
                name: 'cuit',
                type: 'string',
                disabled: true,
                col: 16
            }]
        }

    },
    {
        row: {
            inputs: [{
                displayName: 'Persona contacto',
                name: 'pers_Contacto',
                type: 'string',
                disabled: false,
                col: 28
            },
            {
                displayName: 'Cargo',
                name: 'cargo',
                type: 'string',
                disabled: false,
                col: 28
            },
            {
                displayName: 'E-Mail Fact',
                name: 'mailFact',
                type: 'string',
                disabled: false,
                col: 28
            },
            {
                displayName: 'Teléfono',
                name: 'telefono',
                type: 'string',
                disabled: false,
                col: 16
            }]
        }

    },
    {
        row: {
            inputs: [{
                displayName: 'email',
                name: 'mail',
                type: 'string',
                disabled: false,
                col: 100
            }]
        }

    },
    {
        groupName: 'Parametrización',
        row: {
            inputs: [
                {
                    displayName: 'Inicio facturación',
                    name: 'dia_Inicio_Fact_Mensual',
                    type: 'int',
                    disabled: false,
                    col: 16
                },
                {
                    displayName: 'Fin facturación',
                    name: 'dia_Fin_Fact_Mensual',
                    type: 'int',
                    disabled: false,
                    col: 16
                },
                {
                    displayName: 'Habilitado FA',
                    name: 'fA',
                    type: 'custom_switch',
                    disabled: false,
                    col: 20
                },
                {
                    displayName: 'Tiempo Max Fact.',
                    name: 'idTmpFact',
                    type: 'select',
                    options: [],
                    disabled: false,
                    col: 16
                },
                {
                    displayName: 'Presentación Fact.',
                    name: 'presentacionFact',
                    type: 'select',
                    options: [],
                    disabled: false,
                    col: 16
                },
                {
                    displayName: 'Doc. Respaldatoria',
                    name: 'docRespaldatoria',
                    type: 'select',
                    options: [],
                    disabled: false,
                    col: 16
                },

                {
                    displayName: 'Modo Recepción Autorización',
                    name: 'idTipoAutorizacion',
                    type: 'select',
                    options: [],
                    disabled: false,
                    col: 30
                },
                // {
                //     displayName: 'Editar Fecha Hasta (contratos)',
                //     name: 'editaFechaHasta',
                //     type: 'check',
                //     labelPlacement: 'start',
                //     disabled: false,
                //     col: 30
                // },
                {
                    displayName: 'Aprobación Masiva',
                    name: 'aprobacionMasiva',
                    type: 'check',
                    labelPlacement: 'start',
                    disabled: false,
                    col: 22
                },
                {
                    displayName: 'Telemedicina',
                    name: 'telemedicina',
                    type: 'check',
                    labelPlacement: 'start',
                    disabled: false,
                    col: 16
                },
                {
                    displayName: 'Sub-Venta',
                    name: 'subVentas',
                    type: 'check',
                    labelPlacement: 'start',
                    disabled: false,
                    col: 16
                },
            ]
        }

    },
    {
        row: {
            inputs: [{
                displayName: 'Observación extra',
                name: 'observaciones',
                type: 'long_string',
                disabled: false,
                col: 100
            }]
        }

    }
]